export function aFFILIATEDBUSINESSDISCLOSURERR() {
return [   //2024 Release 2025-08-19 13:20:41
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 146.015,
   left: 96.12,
   width: 69.72,
   height: 14.236
}
,
{
   page: 0,
   name: "Clients Sellers", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 170.375,
   left: 142.8,
   width: 394.233,
   height: 13.581
}
,
{
   page: 0,
   name: "Buyers", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 194.509,
   left: 142.6,
   width: 394.233,
   height: 14.236
}
,
{
   page: 0,
   name: "Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 219.335,
   left: 112.44,
   width: 423.688,
   height: 13.581
}
] }